import styled from 'styled-components';
import Image from 'next/image';

export const BREAK_POINT = {
  SMALLMOBILE: 380,
  MOBILE: 768,
  TABLET: 1100,
};

export const mediaQuery = (width: number, option: 'max' | 'min' = 'max') =>
  `@media (${option}-width: ${width}px)`;

const media = {
  custom: mediaQuery,
  smallmobile: mediaQuery(BREAK_POINT.SMALLMOBILE),
  mobile: mediaQuery(BREAK_POINT.MOBILE),
  tablet: mediaQuery(BREAK_POINT.TABLET),
  minMobile: mediaQuery(BREAK_POINT.MOBILE + 1, 'min'),
  minTablet: mediaQuery(BREAK_POINT.TABLET + 1, 'min'),
};

export const Wrapper = styled.div`
  margin: 0 auto 250px;

  ${media.mobile} {
    margin: 50px 0 70px;
  }

  img {
    max-width: 100%;
  }
`;

export const LettersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  max-width: 1500px;
  margin: auto;
  ${media.mobile} {
    width: 100%;
  }
`;

export const LetterHeading = styled.div`
  width: 100%;
  padding: 2em;
  text-align: center;
  background-color: #fb6431;
  box-sizing: border-box;
`;

export const LetterHeadingInner = styled.div`
  width: 50%;
  margin: auto;
`;

export const ImageFitWidth = styled(Image)`
  max-width: 400px;
  width: 100%;
  height: auto;
`;

export const LetterRow = styled.div`
  border-bottom: 1px solid #606060;
  width: 100%;
  box-sizing: border-box;
  padding: 2em;
  display: flex;
  justify-content: between;
  cursor: pointer;
  ${media.mobile} {
    flex-direction: column;
    padding: 1em 0;
    margin: 1em 0;
  }
`;

export const LetterNumber = styled.div`
  font-family: 'Karla';
  width: 50%;
  font-size: 30px;
  letter-spacing: -1px;
  ${media.mobile} {
    width: 100%;
  }
`;

export const LetterContent = styled.div`
  font-family: 'Noto Serif KR';
`;

export const LetterDate = styled.div`
  font-family: 'Karla';
  font-size: 16px;
  line-height: 2em;
`;

export const LetterTitle = styled.div`
  font-size: 24px;
  margin-bottom: 1em;
`;

export const LetterUl = styled.ul`
  padding-left: 1.7em;
`;

export const LetterLi = styled.li`
  margin-bottom: 0.5em;
  font-size: 15px;
  list-style: disc;
`;

export const Br = styled.br`
  ${media.mobile} {
    display: none;
  }
`;
